interface PaginationProps {
  page: number;
  totalPages: number;
  onChange: (page: number) => void;
}

export default function Pagination({ page, totalPages, onChange }: PaginationProps) {
  if (totalPages <= 1) return null;

  const pages = Array.from({ length: totalPages }, (_, index) => index + 1);
  const baseBtn =
    "flex h-9 min-w-9 cursor-pointer items-center justify-center rounded-md border px-3 text-sm transition whitespace-nowrap";

  return (
    <nav className="mt-8 flex flex-wrap items-center justify-center gap-2" aria-label="分页">
      <button
        type="button"
        disabled={page === 1}
        onClick={() => onChange(page - 1)}
        className={`${baseBtn} ${
          page === 1
            ? "cursor-not-allowed border-background-200 text-foreground-300"
            : "border-background-300 text-foreground-700 hover:border-primary-300 hover:text-primary-600"
        }`}
      >
        <i className="ri-arrow-left-s-line text-lg"></i>
        上一页
      </button>

      {pages.map((item) => (
        <button
          key={item}
          type="button"
          onClick={() => onChange(item)}
          className={`${baseBtn} ${
            item === page
              ? "border-primary-500 bg-primary-500 text-background-50"
              : "border-background-300 text-foreground-700 hover:border-primary-300 hover:text-primary-600"
          }`}
        >
          {item}
        </button>
      ))}

      <button
        type="button"
        disabled={page === totalPages}
        onClick={() => onChange(page + 1)}
        className={`${baseBtn} ${
          page === totalPages
            ? "cursor-not-allowed border-background-200 text-foreground-300"
            : "border-background-300 text-foreground-700 hover:border-primary-300 hover:text-primary-600"
        }`}
      >
        下一页
        <i className="ri-arrow-right-s-line text-lg"></i>
      </button>
    </nav>
  );
}